import { createContext } from 'react';
import { useFilter } from 'components/filter/filters-next/useFilter';

const FilterFormContext = createContext<ReturnType<typeof useFilter<any>>>({
    defaultValue: undefined,
    createFilter: () => {},
    patchFilter: () => {},
    createOrUpdateFilter: () => {},
    deleteFilter: () => {},
});

export { FilterFormContext };
